<template>
  <form @submit.prevent="validateBeforeSubmit">
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <img src="https://s3.amazonaws.com/uifaces/faces/twitter/zeldman/128.jpg">
        </p>
      </figure>
      <div class="media-content">
        <b-field
          :type="{'is-danger': errors.has('reviewer')}"
          :message="[
            errors.firstByRule('reviewer', 'required') ? $t('validate.required') : null,
          ]">
          <b-input
              name="reviewer"
              :placeholder="$t('review.feedback_name')"
              icon="user"
              v-validate="'required'"
              v-model="model.reviewer">
            </b-input>
        </b-field>
        <b-field
          :type="{'is-danger': errors.has('email')}"
          :message="[
            errors.firstByRule('message', 'required') ? $t('validate.required') : null,
            errors.firstByRule('message', 'email') ? $t('validate.email_validate') : null
          ]">
            <b-input
              name="email"
              :placeholder="$t('review.feedback_email')"
              type="email"
              icon="at"
              v-validate="'required|email'"
              v-model="model.email">
            </b-input>
        </b-field>
        <b-field
          :type="{'is-danger': errors.has('message')}"
          :message="[
            errors.firstByRule('message', 'required') ? $t('validate.required') : null,
            errors.firstByRule('message', 'min') ? $t('validate.min')+'100' : null
          ]">
          <b-input
            type="textarea"
            name="message"
            :placeholder="$t('review.feedback_message')"
            v-validate="'required|min:100'"
            v-model="model.message">
          </b-input>
        </b-field>
        <vue-recaptcha v-if="need_capcha"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          :sitekey="key_capcha">
        </vue-recaptcha>
        <b-field label=""
          :type="{'is-danger': errors.has('flag-terms')}"
          :message="[
            errors.firstByRule('flag-terms', 'required') ? $t('validate.required_terms') : null
          ]">
          <b-checkbox v-model="model.flagTerms" name="flag-terms" v-validate="'required:false'">
            {{ $t('review.agree_feedback') }}
          </b-checkbox>
        </b-field>
        <div class="field">
          <p class="control">
            <button :disabled="submit_disable" class="button is-primary is-active">{{ $t('review.submit') }}</button>
          </p>
        </div>
      </div>
    </article>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'
// import VueRecaptcha from 'vue-recaptcha';
import { needCaptcha, getCaptchaKey } from "@/api"

export default {
  name: 'ReviewForm',
  components: {
    VueRecaptcha: () => import('vue-recaptcha'),
  },
  props: {
    //
  },
  data: function () {
    return {
      model: {
        email: '',
        name: '',
        message: ''
      },
      need_capcha: false,
      key_capcha: null,
      submit_disable: false
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    getCaptchaKey().then(response => {
      if (response.data) {
        $this.key_capcha = response.data.data
      }
    })

    needCaptcha().then(response => {
     if (response.data) {
        if (response.data.data == true){
          $this.need_capcha = true
        }
      }
    })

    EventBus.$on('successLeaveReview', () => {
      $this.$toast.open({
        message: $this.$i18n.t('review.review_succes'),
        type: 'is-success',
        position: 'is-bottom'
      })
      $this.model = {}
      $this.submit_disable = true
      $this.errors.items = []
    })
  },
  beforeDestroy () {
    EventBus.$off('successLeaveReview')
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this;
      if ($this.need_capcha){
        
        $this.$validator.validateAll().then((result) => {
          if (result) {
            $this.$refs.recaptcha.execute();
            return;
          }
          $this.$toast.open({
            message: $this.$i18n.t('notify.form_error'),
            type: 'is-danger',
            position: 'is-bottom'
          })
        });
        
      }
      else{
        $this.$validator.validateAll().then((result) => {
          if (result) {
            $this.sendPayload($this.model)
          }
        })
      }
    },
    onCaptchaVerified: function (recaptchaToken) {
      let $this = this;
      $this.$refs.recaptcha.reset();

      let payload = $this.model
      payload["g-recaptcha-response"] = recaptchaToken

      $this.sendPayload(payload)
      
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    sendPayload: function (payload) {
      let $this = this;

      $this.$store.dispatch('leaveReview', payload)
    } 
  }
}
</script>

<style scoped>
</style>
<style>
</style>